/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPdfSplitPreviewDocumentsInner } from './HchbPdfSplitPreviewDocumentsInner';
import {
    HchbPdfSplitPreviewDocumentsInnerFromJSON,
    HchbPdfSplitPreviewDocumentsInnerFromJSONTyped,
    HchbPdfSplitPreviewDocumentsInnerToJSON,
    HchbPdfSplitPreviewDocumentsInnerToJSONTyped,
} from './HchbPdfSplitPreviewDocumentsInner';

/**
 * Not-yet-pushed PDFs larger than the HCHB 10 MB limit, sized from S3.
 * @export
 * @interface HchbPdfSplitPreview
 */
export interface HchbPdfSplitPreview {
    /**
     * 
     */
    pdf_splitting_enabled: boolean;
    /**
     * 
     */
    documents: Array<HchbPdfSplitPreviewDocumentsInner>;
}

/**
 * Check if a given object implements the HchbPdfSplitPreview interface.
 */
export function instanceOfHchbPdfSplitPreview(value: object): value is HchbPdfSplitPreview {
    if (!('pdf_splitting_enabled' in value) || value['pdf_splitting_enabled'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function HchbPdfSplitPreviewFromJSON(json: any): HchbPdfSplitPreview {
    return HchbPdfSplitPreviewFromJSONTyped(json, false);
}

export function HchbPdfSplitPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPdfSplitPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'pdf_splitting_enabled': json['pdf_splitting_enabled'],
        'documents': ((json['documents'] as Array<any>).map(HchbPdfSplitPreviewDocumentsInnerFromJSON)),
    };
}

export function HchbPdfSplitPreviewToJSON(json: any): HchbPdfSplitPreview {
    return HchbPdfSplitPreviewToJSONTyped(json, false);
}

export function HchbPdfSplitPreviewToJSONTyped(value?: HchbPdfSplitPreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pdf_splitting_enabled': value['pdf_splitting_enabled'],
        'documents': ((value['documents'] as Array<any>).map(HchbPdfSplitPreviewDocumentsInnerToJSON)),
    };
}

